export default "__VITE_ASSET__UOl0Qxt4__"